"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../../basics/Icon"));
var BaseModal_1 = __importDefault(require("../BaseModal"));
var VerticalSpacer_1 = __importDefault(require("../../../utils/VerticalSpacer"));
var typography_1 = require("../../../typography");
var styles_1 = require("./styles");
var VS_1 = { small: 24, medium: 24, large: 24 };
var Modal = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.align, align = _b === void 0 ? 'left' : _b, onClose = _a.onClose, commonProps = __rest(_a, ["title", "children", "align", "onClose"]);
    return (react_1.default.createElement(BaseModal_1.default, { title: title, onClose: onClose }, function (_a) {
        var ref = _a.ref, rest = __rest(_a, ["ref"]);
        return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "Modal" }, commonProps, rest, { ref: ref }),
            react_1.default.createElement(styles_1.Box, null,
                react_1.default.createElement(styles_1.CloseWrapper, { onClick: onClose, color: "BLUE_50", hoverColor: "BLUE_60" },
                    react_1.default.createElement(Icon_1.default, { name: "close" })),
                react_1.default.createElement(styles_1.Content, null,
                    react_1.default.createElement(VerticalSpacer_1.default, { amount: VS_1 },
                        react_1.default.createElement(styles_1.Header, { "$align": align },
                            react_1.default.createElement(typography_1.Heading, { level: "3", color: "BLUE_50" }, title)),
                        children)))));
    }));
};
exports.Modal = Modal;
exports.Modal.config = {
    bodyLevel: '3',
};
exports.default = exports.Modal;
